/**
 * <TutorCloseOutSkeleton> — la forme du bilan de séance pendant que la clôture qualité se lit.
 *
 * L'écran d'aujourd'hui tournait une roue plein écran : ici, la tête (Zoé, le titre, la date), les
 * trois cartes de « Les bases », deux cartes d'élève et la carte « Côté plateforme », avec leurs
 * vrais intitulés de section.
 */
import React from "react"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { SectionLabel } from "../../atoms/typography/SectionLabel"
import { Card } from "../../molecules/Card"

const AXES = 3
const STUDENTS = 2

export function TutorCloseOutSkeleton() {
    return (
        <Stack gap="6">
            <Stack gap="2" align="center">
                <Skeleton shape="circle" size={86} />
                <Skeleton textSize="text-2xl" width={220} />
                <Skeleton textSize="text-sm" width={180} />
            </Stack>
            <Stack gap="3">
                <SectionLabel>Les bases</SectionLabel>
                {Array.from({ length: AXES }, (_, index) => (
                    <Card key={index} p="4">
                        <Row gap="2" align="center">
                            <Skeleton shape="circle" size={20} />
                            <Skeleton textSize="text-md" width={120} />
                        </Row>
                    </Card>
                ))}
            </Stack>
            <Stack gap="3">
                <SectionLabel>Tes élèves</SectionLabel>
                {Array.from({ length: STUDENTS }, (_, index) => (
                    <Card key={index} p="4">
                        <Stack gap="3">
                            <Row gap="3" align="center">
                                <Skeleton shape="circle" size={36} />
                                <Stack gap="1">
                                    <Skeleton textSize="text-md" width={90} />
                                    <Skeleton textSize="text-xs" width={50} />
                                </Stack>
                            </Row>
                            <Skeleton shape="block" height={6} />
                            <Skeleton textSize="text-sm" width="70%" />
                        </Stack>
                    </Card>
                ))}
            </Stack>
            <Stack gap="3">
                <SectionLabel>Côté plateforme</SectionLabel>
                <Card p="4">
                    <Stack gap="2" align="center">
                        <Skeleton textSize="text-md" width="80%" />
                        <Skeleton textSize="text-sm" width="60%" />
                    </Stack>
                </Card>
            </Stack>
        </Stack>
    )
}
